import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';
import { categoryCards, featuredArticles, hotArticles } from '@/mocks/homeData';
import { useEffect } from 'react';

export default function CategoryPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);

  useEffect(() => {
    const collectionSchema = {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      'name': '热门分类 - 吃瓜网',
      'description': '吃瓜网热门分类：明星八卦、网红翻车、擦边吃瓜、经典大瓜。按你喜欢的口味，精准吃瓜。',
      'url': 'https://www.chiguawang.com/category',
      'isPartOf': { '@type': 'WebSite', 'name': '吃瓜网', 'url': 'https://www.chiguawang.com' },
      'inLanguage': 'zh-CN',
    };

    const breadcrumbSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      'itemListElement': [
        { '@type': 'ListItem', 'position': 1, 'name': '首页', 'item': 'https://www.chiguawang.com' },
        { '@type': 'ListItem', 'position': 2, 'name': '全部分类' },
      ],
    };

    const schemas = [
      { id: 'cat-collection-schema', data: collectionSchema },
      { id: 'cat-breadcrumb-schema', data: breadcrumbSchema },
    ];

    schemas.forEach(({ id: sid, data }) => {
      const existing = document.getElementById(sid);
      if (existing) existing.remove();
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = sid;
      script.textContent = JSON.stringify(data);
      document.head.appendChild(script);
    });

    return () => {
      schemas.forEach(({ id: sid }) => {
        const el = document.getElementById(sid);
        if (el) el.remove();
      });
    };
  }, []);

  const allArticles = [...featuredArticles, ...hotArticles];

  const categoryArticleCounts = categoryCards.map(cat => ({
    ...cat,
    mockCount: allArticles.filter(a => (a as any).categorySlug === cat.id).length,
  }));

  return (
    <>
      <Navbar />
      <main className="pt-16 md:pt-18 bg-background-50">
        {/* Header */}
        <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            {/* Breadcrumb */}
            <nav className="flex items-center gap-1.5 text-xs text-foreground-400 mb-4" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-600">全部分类</span>
            </nav>
            <h1 className="font-heading text-2xl md:text-3xl text-foreground-950">热门分类</h1>
            <p className="text-foreground-500 text-sm mt-2">按你喜欢的口味，精准吃瓜</p>
          </div>
        </section>

        {/* Category Grid */}
        <section className="py-10 md:py-14 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {categoryArticleCounts.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.id}`}
                  className="group bg-background-50 rounded-2xl border border-secondary-200/60 p-6 md:p-7 hover:border-primary-300 transition-all duration-300 cursor-pointer"
                >
                  <div className={`w-14 h-14 rounded-2xl ${cat.lightColor} flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300`}>
                    <i className={`${cat.icon} text-2xl ${cat.textColor}`}></i>
                  </div>
                  <div className="flex items-baseline justify-between mb-2">
                    <h3 className="font-heading text-xl text-foreground-950 group-hover:text-primary-500 transition-colors">
                      {cat.name}
                    </h3>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{cat.count.toLocaleString()}条</span>
                  </div>
                  <p className="text-foreground-500 text-sm leading-relaxed mb-4">{cat.description}</p>
                  {cat.mockCount > 0 && (
                    <p className="text-xs text-primary-500 mb-3">
                      <i className="ri-article-line mr-1"></i> {cat.mockCount} 篇最新内容
                    </p>
                  )}
                  <div className="flex items-center text-foreground-300 text-xs group-hover:text-primary-500 transition-colors">
                    <span>浏览全部</span>
                    <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform"></i>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Quick Stats */}
        <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="font-heading text-xl md:text-2xl text-foreground-950">平台数据一览</h2>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
              {categoryCards.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.id}`}
                  className="text-center p-5 md:p-6 rounded-2xl bg-background-50 border border-secondary-200/60 hover:border-primary-200 transition-all cursor-pointer"
                >
                  <p className="font-heading text-2xl md:text-3xl text-primary-500 font-bold">{cat.count.toLocaleString()}</p>
                  <p className="text-foreground-500 text-xs md:text-sm mt-2">{cat.name}</p>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}